<template>
    <div style="height: 100%;">
        
            <van-search v-model="param" show-action placeholder="请输入搜索关键词" @clear="getHeadStaffCardInfo">
                <template #left>
                    <el-button size="medium" type="primary" @click="openOpenCard">新增</el-button>
                    <el-select v-model="hzstoreid" placeholder="门店选择" style="width: 100px;" size="medium" clearable @change="storeChange">
                        <el-option v-for="item in stores" :key="item.storeid" :label="item.storename" :value="item.storeid"></el-option>
                    </el-select>
                </template>
                <template #action>
                    <div @click="onSearch">搜索</div>
                </template>
            </van-search>
        
        <!--<van-search v-model="param" show-action placeholder="请输入搜索关键词" @search="onSearch" @cancel="onCancel"/>-->
        <el-table border height="calc(100% - 6rem)" :data="headStaffs" size="mini" style="text-align: center" highlight-current-row :show-header="false">
            <el-table-column label="合作门店" align="center"prop="hzstorename">
                <template slot-scope="scope">
                    <el-row>
                        <el-col :span="3">
                            <el-avatar :size="50" :src="require('../../assets/nan.png')" v-if="scope.row.sex==1"></el-avatar>
                            <el-avatar :size="50" :src="require('../../assets/nv.png')" v-if="scope.row.sex!=1"></el-avatar>
                        </el-col>
                        <el-col :span="21">
                            <el-row>
                                <el-col :span="8">{{scope.row.hzstorename}}</el-col>
                                <el-col :span="8">{{scope.row.cardnumber}}</el-col>
                                <el-col :span="8">{{scope.row.membername}}</el-col>
                            </el-row>
                            <el-row>
                                <el-button  size="mini" @click="openCash(scope.row)">消耗</el-button>
                        
                                <el-button  size="mini" @click="openBuyCardCourse(scope.row)">买课程</el-button>
                            
                                <el-button  size="mini" @click="openCardCourse(scope.row)">课程信息</el-button>
    
                                <el-button  size="mini" @click="openCardHistory(scope.row)">交易历史</el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>
<script>
    import nan from '../../assets/nan.png'
    import nv from '../../assets/nv.png'
    export default {
        data() {
            return {
                hzstoreid:"",
                param:"",
                stores:[],
                imagenan:nan,
                iamgenv:nv,
                param:"",
                storeid:localStorage.getItem("storeid"),
                staffid:localStorage.getItem("staffid"),
                headStaffs:[],
            }
        },
        created() {
            this.getHeadStaffCardInfo();
            this.getInteboStore();
        },
        methods:{
            storeChange(){
                this.getHeadStaffCardInfo();
            },
            getInteboStore(){
                this.$post("inteboStore/getInteboStaffHeadStore",{staffid:localStorage.getItem("staffid")}).then(res=>{
                    if(res.sucess){
                        this.stores=res.object;
                    }
                    else{
                        this.$message.error(res.$message);
                    }
                });
            },
            openOpenCard(){
                this.$router.push({
                    path:"/opencard"
                });
            },
            openCardHistory(item){
                this.$router.push({
                    path:"/intebocardhistory",
                    query:{
                        cardid:item.cardid
                    }
                });
            },
            openCardCourse(item){
                this.$router.push({
                    path:"/cardcourse",
                    query:{
                        cardid:item.cardid
                    }
                });
            },
            openBuyCardCourse(item){
                this.$router.push({
                    path:"/buycardcourse",
                    query:{
                        cardnumber:item.cardnumber
                    }
                });
            },
            openCash(item){
                this.$router.push({
                    path:"/cash",
                    query:{
                        cardnumber:item.cardnumber
                    }
                });
            },
            onSearch(){
                this.getHeadStaffCardInfo();
            },
            onCancel(){

            },
            getHeadStaffCardInfo(){
                this.$post("ddstaff/getInteboHeaderStaffCardInfo",{storeid:this.hzstoreid,param:this.param,staffid:this.staffid}).then(res=>{
                    if(res.sucess){
                        this.headStaffs=res.object;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/page/intebo/headstaff.vue